// extracted by mini-css-extract-plugin
export default {"tasks":"mN-z","task":"nN-z","svg":"oN-z","text":"pN-z"};